export const PRICES = {
  'gpt-4o': { input: 2.50, output: 10.00 },
  'gpt-5.2': { input: 1.75, output: 14.00 },
  'gpt-5.1': { input: 1.25, output: 10.00 },
  'gpt-5': { input: 1.25, output: 10.00 },
  'gpt-4o-2024-11-20': { input: 2.50, output: 10.00 },
  'gpt-4o-2024-08-06': { input: 2.50, output: 10.00 },
  'gpt-4o-2024-05-13': { input: 5.00, output: 15.00 },
  'gpt-4o-mini': { input: 0.15, output: 0.60 },
  'gpt-4-turbo': { input: 10.00, output: 30.00 },
  'gpt-3.5-turbo': { input: 0.50, output: 1.50 },
  'claude-opus-4-1': { input: 15.00, output: 75.00 },
  'claude-opus-4-5': { input: 5.00, output: 25.00 },
  'claude-opus-4-6': { input: 5.00, output: 25.00 },
  'claude-sonnet-4-5': { input: 3.00, output: 14.00 },
  'claude-sonnet-4-6': { input: 3.00, output: 14.00 },
};

export function getModel(template) {
  let llmModel, llmVendor;
  switch (true) {
    case template.indexOf('claude-opus-4-6') > -1: llmVendor = 'claude'; llmModel = 'claude-opus-4-6'; break;
    case template.indexOf('claude-opus-4-5') > -1: llmVendor = 'claude'; llmModel = 'claude-opus-4-5'; break;
    case template.indexOf('claude-opus-4-1') > -1: llmVendor = 'claude'; llmModel = 'claude-opus-4-1'; break;
    case template.indexOf('claude-sonnet-4-5') > -1: llmVendor = 'claude'; llmModel = 'claude-sonnet-4-5'; break;
    case template.indexOf('claude-sonnet-4-6') > -1: llmVendor = 'claude'; llmModel = 'claude-sonnet-4-6'; break;
    
    case template.indexOf('gpt-4o-2024-05-13') > -1: llmVendor = 'openai'; llmModel = 'gpt-4o-2024-05-13'; break;
    case template.indexOf('gpt-4o-2024-11-20') > -1: llmVendor = 'openai'; llmModel = 'gpt-4o-2024-11-20'; break;
    case template.indexOf('gpt-4o-2024-08-06') > -1: llmVendor = 'openai'; llmModel = 'gpt-4o-2024-08-06'; break;
    case template.indexOf('gpt-4o-mini') > -1: llmVendor = 'openai'; llmModel = 'gpt-4o-mini'; break;
    case template.indexOf('gpt-4o') > -1: llmVendor = 'openai'; llmModel = 'gpt-4o'; break;
    case template.indexOf('gpt-4-turbo') > -1: llmVendor = 'openai'; llmModel = 'gpt-4-turbo'; break;
    case template.indexOf('gpt-5.2') > -1: llmVendor = 'openai'; llmModel = 'gpt-5.2'; break;
    case template.indexOf('gpt-5.1') > -1: llmVendor = 'openai'; llmModel = 'gpt-5.1'; break;
    case template.indexOf('gpt-5') > -1: llmVendor = 'openai'; llmModel = 'gpt-5'; break;
    case template.indexOf('gpt-3.5-turbo') > -1: llmVendor = 'openai'; llmModel = 'gpt-3.5-turbo'; break;
    // Default
    default: llmVendor = 'openai'; llmModel = 'gpt-4o';
  }
  return { llmVendor, llmModel };
}

export default {
  PRICES,
  getModel,
}